import thunk from 'redux-thunk';
import {
  createStore as reduxCreateStore,
  compose,
  applyMiddleware,
} from 'redux';
import { routerMiddleware } from 'connected-react-router';
import { History } from 'history';
import rootReducer, { StateType } from '../reducers';
import { analytics } from '../middlewares/analytics';
import { exposeOriginalQueryKey } from '../middlewares/exposeOriginalQueryKey';
import { doctrineAnalytics } from '../../utils/analyticsUtils';
import { isClientSide } from '../../utils/ssrUtils';

const middlewares = (history: History) => [
  exposeOriginalQueryKey,
  thunk,
  routerMiddleware(history),
  analytics(doctrineAnalytics),
];

const injectDevtool = () => {
  /* eslint-disable */
  if (process.env.NODE_ENV === 'test') return compose;

  if (isClientSide && window.__REDUX_DEVTOOLS_EXTENSION__) {
    return window.__REDUX_DEVTOOLS_EXTENSION__();
  }

  return compose;
  /* eslint-enable */
};

const enhancer = (history: History) =>
  compose(applyMiddleware(...middlewares(history)), injectDevtool());

export function createStore(
  initialState: Partial<StateType>,
  history: History,
) {
  const store = reduxCreateStore(
    rootReducer(history),
    initialState,
    enhancer(history),
  );
  return store;
}
